(function () {
  'use strict';

  function initReadMore() {
    document.querySelectorAll('.pdp-read-more').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('aria-controls');
        var target = targetId ? document.getElementById(targetId) : btn.previousElementSibling;
        if (!target) return;

        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        btn.classList.toggle('is-expanded', !expanded);
        target.classList.toggle('is-expanded', !expanded);
        btn.querySelector('.pdp-read-more__label').textContent = expanded ? 'Read more' : 'Read less';
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.pdp-accordion__trigger').forEach(function (trigger) {
      if (trigger.dataset.bound) return;
      trigger.dataset.bound = '1';

      trigger.addEventListener('click', function () {
        var accordion = trigger.closest('.pdp-accordion');
        if (!accordion) return;

        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initHorizontalThumbs() {
    document.querySelectorAll('.pdp-gallery--horizontal').forEach(function (gallery) {
      var thumbs = gallery.querySelector('.pdp-gallery__thumbs');
      if (!thumbs || thumbs.dataset.wheelBound) return;
      thumbs.dataset.wheelBound = '1';

      thumbs.addEventListener(
        'wheel',
        function (e) {
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          if (thumbs.scrollWidth <= thumbs.clientWidth) return;
          e.preventDefault();
          thumbs.scrollLeft += e.deltaY;
        },
        { passive: false }
      );
    });
  }

  function initGalleryZoom() {
    document.querySelectorAll('[data-pdp-zoom]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var gallery = btn.closest('.pdp-gallery');
        if (!gallery) return;
        var active = gallery.querySelector('.pdp-gallery__item:not([hidden]) img');
        if (!active) return;

        var modal = document.querySelector('product-modal');
        if (modal && typeof modal.show === 'function') {
          modal.show(active);
        }
      });
    });
  }

  function initGalleryShare() {
    document.querySelectorAll('[data-pdp-share]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var shareData = {
          title: document.title,
          url: window.location.href
        };

        if (navigator.share) {
          navigator.share(shareData).catch(function () {});
          return;
        }

        if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    });
  }

  function initGalleryWishlist() {
    document.querySelectorAll('.pdp-gallery__wishlist').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        var mainWishlist = document.querySelector('.wishlist-btn');
        if (mainWishlist) {
          mainWishlist.click();
        }
      });
    });
  }

  function init() {
    initReadMore();
    initAccordions();
    initHorizontalThumbs();
    initGalleryZoom();
    initGalleryShare();
    initGalleryWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
